import { render, staticRenderFns } from "./test-bundle.vue?vue&type=template&id=c41a85e6&"
import script from "./test-bundle.vue?vue&type=script&lang=js&"
export * from "./test-bundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports